import React from 'react';
import styled from 'styled-components';

const Styles = styled.div` 

.wrapperbox{
    background: #50a3a2;
    background: -webkit-linear-gradient(top left, #d9d2cc 0%, #b1a8a0 100%);
    background: -moz-linear-gradient(top left, #d9d2cc 0%, #b1a8a0 100%);
    background: -o-linear-gradient(top left, #d9d2cc 0%, #b1a8a0 100%);
    background: linear-gradient(to bottom right, #d9d2cc 0%, #b1a8a0 100%);
    
	// top: 50%;
	// left: 0;
	// width: 100%;
	// height: 400px;
	// overflow: hidden;
    
	// margin-top: -200px;
    // position: absolute;

}

.containerbox{
	max-width: 600px;
	margin: 0 auto;
	padding: 80px 0;
	height: 300px;
	text-align: center;
}

.bg-bubbles{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	
	z-index: 1;
	
	.objecticon{
		&:nth-child(1){
			left: 10%;
		}
		
		&:nth-child(2){
			left: 20%;
			
			width: 80px;
			height: 80px;
			
			animation-delay: 2s;
			animation-duration: 17s;
		}
		
		&:nth-child(3){
			left: 25%;
			animation-delay: 4s;
		}
		
		&:nth-child(4){
			left: 40%;
			width: 60px;
			height: 60px;
			
			animation-duration: 22s;
			
			background-color: fade(white, 25%);
		}
		
		&:nth-child(5){
			left: 70%;
		}
		
		&:nth-child(6){
			left: 80%;
			width: 120px;
			height: 120px;
			
			animation-delay: 3s;
			background-color: fade(white, 20%);
		}
		
		&:nth-child(7){
			left: 32%;
			width: 160px;
			height: 160px;
			
			animation-delay: 7s;
		}
		
		&:nth-child(8){
			left: 55%;
			width: 20px;
			height: 20px;
			
			animation-delay: 15s;
			animation-duration: 40s;
		}
		
		&:nth-child(9){
			left: 25%;
			width: 10px;
			height: 10px;
			
			animation-delay: 2s;
			animation-duration: 40s;
			background-color: fade(white, 30%);
		}
		
		&:nth-child(10){
			left: 90%;
			width: 160px;
			height: 160px;

			animation-delay: 11s;
		}
	}
}

.objecticon {
    top:400px;    
       
    display:block;
    position:absolute;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background-color: white;   
    opacity:15%;

    -webkit-animation: square 25s infinite;
    animation: square 25s infinite;
    -webkit-transition-timing-function: linear;
    transition-timing-function: linear;
}

@-webkit-keyframes square {
  0%   { transform: translateY(0); }
  100% { transform: translateY(-700px) rotate(600deg); }
}
@keyframes square {
  0%   { transform: translateY(0); }
  100% { transform: translateY(-700px) rotate(600deg); }
}


`;



const Testpage = () => {

	return (
		<Styles>
			<div className="wrapperbox">
				<div className="containerbox">
					<ul className="bg-bubbles">
						<li className="objecticon"></li>
						<li className="objecticon"></li>
						<li className="objecticon"></li>
						<li className="objecticon"></li>
						<li className="objecticon"></li>
						<li className="objecticon"></li>
						<li className="objecticon"></li>
						<li className="objecticon"></li>
						<li className="objecticon"></li>
						<li className="objecticon"></li>
					</ul>
				</div>
			</div>


			<div className="row">
				<div className="container">

					<h2>TESTING SECTION</h2>

				</div>
			</div>

		</Styles>
	);
};

export default Testpage;


